<template>
  <Modal
    class="project-analysis-text-modal modal-themes-auto-generate"
    header-tag="h3"
    :ref="modalRef"
    :show="show"
    :isAutoSuggest="true"
    :widerFormat="true"
    @close="closeModal"
    style="display: flex; flex-direction: column; position: relative"
  >
    <template #header>
      <div
        style="
          position: relative;
          display: flex;
          flex-direction: row;
          width: 100%;
          justify-content: flex-end;
          margin-bottom: -1rem;
        "
      >
        <h2 style="display: flex; width: 100%">
          <VisibleText>Generate themes</VisibleText>
        </h2>

        <div
          style="
            font-size: 0.9rem;
            font-weight: 500;
            margin-left: auto;
            margin-right: 0.5rem;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            width: 100%;
          "
          v-if="textAIStatus == 'complete'"
        >
          <SvgIconDecorative icon="success" />
          <VisibleText>AI text analysis enabled</VisibleText>
        </div>

        <div
          style="
            font-size: 0.9rem;
            font-weight: 500;
            margin-left: auto;
            display: flex;
            flex-direction: row;
            width: 100%;
            justify-content: flex-end;
          "
          v-if="
            !hasPreProcessedText && textAIStatus !== 'processing' && textAIStatus !== 'complete'
          "
        >
          <SvgIconDecorative style="margin: auto 0" icon="error" />
          <VisibleText style="margin: auto 0">AI disabled</VisibleText>
          <button class="btn-secondary" style="" @click="preprocessAI" v-if="!propReadOnly">
            <SvgIconDecorative icon="information" style="margin: auto" />
            <VisibleText style="color: var(--base-colour); text-decoration: underline"
              >Click here to process text</VisibleText
            >
          </button>
        </div>

        <div
          style="
            font-size: 0.9rem;
            font-weight: 500;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            width: 30rem;
          "
          v-if="textAIStatus == 'processing'"
        >
          <div
            class="also-found__loading-spinner spinner"
            style="display: flex; width: 1rem; height: 1rem; margin: auto 1rem"
          ></div>
          <VisibleText style="display: flex; margin: auto 1rem"
            >Processing text analysis for AI.</VisibleText
          >
        </div>
      </div>
    </template>
    <div
      style="
        display: flex;
        flex-direction: row;
        position: relative;
        height: 100%;
        margin-top: -1rem;
      "
    >
      <div
        class="suggested-themes__wrapper suggested-themes__blue"
        style="position: relative; margin-bottom: 2em; padding: 0.5rem; height: 100%"
        :style="'width:' + savedWidth + '%'"
      >
        <h3 class="suggested-themes__heading">
          <VisibleText>Themes to keep</VisibleText>
        </h3>
        <div v-if="themeList && textAnalysisObject" style="position: relative">
          <!-- Main theme row content  -->
          <div
            style="
              display: flex;
              flex-direction: column;
              width: 97%;
              margin: auto;
              position: relative;
            "
            v-for="(theme, key) in themeList"
            :key="key"
          >
            <div
              class="theme__list-row"
              style="
                display: flex;
                flex-direction: row;
                display: flex;
                align-items: center;
                position: relative;
                padding: 0;
                margin-bottom: 0.5rem;
                position: relative;
              "
            >
              <!-- Theme title column -->
              <div style="display: flex; flex-direction: column; width: 15rem; position: relative">
                <div style="display: flex; flex-direction: row; position: relative">
                  <!-- <div                
                    style="
                      display: flex;
                      flex-direction: column;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      margin-left: 0.5rem;
                    ">
                    <strong>
                    {{ theme.name }}
                    </strong>
                  </div> -->

                  <div v-if="!propReadOnly">
                    <InputEditable
                      :value="theme.name"
                      :uuid="`saved-themes-${key}`"
                      @updateInput="renameThemeTitle(theme, $event, 'theme-list')"
                      :isBold="true"
                      :isSmall="true"
                    />
                  </div>
                  <div v-else>
                    {{ theme.name }}
                  </div>

                  <div
                    v-if="duplicateIndex == key"
                    style="font-size: 0.7rem; color: var(--state-invalid-colour)"
                  >
                    <VisibleText>No duplicate titles allowed. Please try another.</VisibleText>
                  </div>
                </div>
                <div style="display: flex; flex-direction: row; position: relative">
                  <SourcePopup :themeName="theme.name" :themeSource="theme.source" />
                  <button
                    class="table__toolbar-btn"
                    style="
                      font-size: 0.8em;
                      padding: 0.3em 0.6em 0.3em 0.3em;
                      margin: 0.5rem;
                      height: 2rem;
                    "
                    @click="removeFromListForSaving(theme)"
                    v-if="theme.is_autogenerated"
                  >
                    <SvgIconDecorative icon="minus" />
                    <VisibleText>Remove</VisibleText>
                  </button>
                </div>
              </div>
              <!-- Bar -->
              <div style="border-left: 0.2rem solid var(--primary); height: 3rem"></div>

              <!-- Simple coverage section -->
              <div
                class="theme__list-row-coverage-title"
                style="display: flex; flex-direction: row; flex: 0 0 4vw; position: relative"
              >
                <div v-if="themesReloading.includes(theme._id)" style="position: relative">
                  <span
                    class="also-found__loading-spinner spinner"
                    style="
                      position: absolute;
                      top: 1rem;
                      left: 3rem;
                      height: 2rem;
                      width: 2rem;
                      margin: auto;
                    "
                  ></span>
                </div>
                <CoveragePopup
                  style="width: 4vw"
                  :theme="theme"
                  :hasPreProcessedText="hasPreProcessedText"
                  :includeSmartCoverage="includeSmartCoverage"
                  :sortedResponsesLength="unsortedResponses.length"
                  :hasFilter="
                    Boolean(
                      textAnalysisObject.filterParams &&
                      Object.keys(textAnalysisObject.filterParams).length,
                    )
                  "
                />

                <SentimentPopup
                  :sortedResponsesLength="unsortedResponses.length"
                  v-if="textAnalysisObject.includeSentiments == 'include' && theme.sentiment"
                  :theme="theme"
                />
              </div>
              <!-- Time series coverage section -->
              <!-- <div
                v-if="
                  themeDualAxisCharts[index] &&
                  themeDualAxisCharts[index].chart_data &&
                  themeDualAxisCharts[index].chart_data.length
                "
                class="theme__list-row-coverage"
                style="
                  flex: 0 0 20vw; /* fixed width for chart */
                  max-width: 20vw;
                  min-width: 20vw;
                  overflow: hidden;
                "
              >
                <PerformanceCharts
                  :chart-data="themeDualAxisCharts[index].chart_data"
                  :isLoading="false"
                  :isThematic="true"
                  :minimalMode="true"
                />
              </div> -->
              <!-- Sentiments section -->
              <!-- <SentimentCharts
                v-if="
                  hasPreProcessedText &&
                  textAnalysisObject.includeSentiments == 'include' &&
                  (!themeDualAxisCharts[index] ||
                    !themeDualAxisCharts[index].chart_data ||
                    !themeDualAxisCharts[index].chart_data.length)
                "
                :pos-neg-data="generatePosNegData(findResponses(theme), theme.name)"
              /> -->
              <!-- Keywords section -->
              <div
                class="theme__list-row-info"
                style="position: relative; flex: 1 1 auto; min-width: 0; white-space: nowrap"
              >
                <EditableKeywordsPopup
                  :theme="theme"
                  :hasPreProcessedText="hasPreProcessedText"
                  :textAnalysisObject="textAnalysisObject"
                  :bannedKeywords="this.textAnalysisObject.bannedKeywords"
                  :isInAutoView="true"
                  @addKeyword="addKeyword($event)"
                  @removeKeyword="removeKeyword($event)"
                  :hideLabel="true"
                />
                <NotesPopup
                  :clientQuestionId="textAnalysisObject.selectedTextQuestion._id"
                  :themesLength="sortedThemes.length"
                  :theme="theme"
                  :themeIndex="key"
                  :allResponses="unsortedResponses"
                  :hasPreProcessedText="hasPreProcessedText"
                  @selectThisResponse="selectThisResponse($event)"
                  :showCoverageDetails="textAnalysisObject.showCoverageDetails"
                  @updateTheme="this.updateTheme($event)"
                  @refreshTheme="this.$emit('refreshTheme', $event)"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="!themeList || themeList.length === 0">
          <p>
            <VisibleText>
              You have no themes. Try generating new themes from one of the methods on the right.
            </VisibleText>
          </p>
        </div>
        <div v-if="isSaving">
          <VisibleText>Refreshing saved themes.</VisibleText>
          <span class="suggested-themes__loading-spinner spinner"></span>
        </div>
      </div>

      <div :style="'width:' + (100 - savedWidth) + '%'">
        <div class="search-mode-toggle-wrapper">
          <div class="search-mode-toggle">
            <label :class="{ active: searchMode === 'semantic' }" style="font-size: 1.1rem">
              <input type="radio" value="semantic" v-model="searchMode" />
              Keyword and semantic
            </label>

            <label :class="{ active: searchMode === 'cluster' }" style="font-size: 1.1rem">
              <input type="radio" value="cluster" v-model="searchMode" />
              Topic clusters
            </label>
          </div>
        </div>

        <div style="display: flex; flex-direction: row; margin-bottom: 2rem">
          <div
            style="display: flex; flex-direction: column; margin: 0 1rem; width: 100%"
            v-if="searchMode == 'semantic'"
          >
            <div style="font-size: 1rem; text-align: center; margin-bottom: 1rem">
              <VisibleText>
                Analyze text using rules, keywords, or semantic scoring. Pick a model to get
                started.
              </VisibleText>
            </div>

            <div class="model-picker">
              <div class="model-filters">
                <div class="filter-bar">
                  <button
                    :class="{ active: mode.private_custom_topics }"
                    @click="mode.private_custom_topics = !mode.private_custom_topics"
                  >
                    My models
                  </button>
                  <button
                    :class="{ active: mode.team_custom_topics }"
                    @click="mode.team_custom_topics = !mode.team_custom_topics"
                  >
                    Team models
                  </button>
                  <button
                    :class="{ active: mode.public_custom_topics }"
                    @click="mode.public_custom_topics = !mode.public_custom_topics"
                  >
                    Public models
                  </button>
                </div>
                <div style="font-size: 0.9rem">
                  <strong>
                    <VisibleText>Selected models:</VisibleText>
                  </strong>
                </div>
                <div class="selected-tags">
                  <span v-for="model in filteredSelectedCustomModels" class="tag" :key="model.id">
                    <a
                      :href="`/custom-text-model/${model.id}`"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="view-link"
                      @click.stop
                    >
                      <SvgIconDecorative icon="externalLink" style="width: 1rem" />{{ model.name }}
                    </a>
                    <button @click="toggleSelection(model)">×</button>
                  </span>
                </div>
              </div>

              <div style="display: flex; flex-direction: column; height: 12rem">
                <input
                  type="text"
                  v-model="searchCustomModelQuery"
                  placeholder="Search models..."
                  style="margin-bottom: 0"
                />
                <ul class="model-list">
                  <li v-for="model in filteredCustomModels" :key="model.id">
                    <label>
                      <input
                        type="checkbox"
                        :checked="selectedCustomModels.includes(model.id)"
                        @change="toggleSelection(model)"
                      />
                      {{ model.name }}
                      <a
                        :href="`/custom-text-model/${model.id}`"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="view-link"
                        @click.stop
                      >
                        <SvgIconDecorative icon="externalLink" style="width: 1rem" />See model
                      </a>
                    </label>
                  </li>
                </ul>
              </div>

              <div class="advanced-options">
                <strong style="font-size: 0.9rem"> Advanced options </strong>
                <label
                  ><input
                    type="checkbox"
                    v-model="mode.include_machine_learning"
                    :disabled="!hasPreProcessedText && textAIStatus !== 'complete'"
                  />
                  Include machine learning matches (if a model exists)</label
                >
                <label
                  ><input type="checkbox" v-model="mode.include_all_themes" /> Include empty
                  matches</label
                >
                <button
                  class="suggested-themes__empty-auto-generate-btn btn-default"
                  style="width: 15rem"
                  role="button"
                  @click.stop="autoGenerateThemes()"
                  :disabled="disableAutoGen"
                >
                  <div v-if="!isLoading">Generate themes</div>
                  <div v-else>
                    <VisibleText>Generating themes</VisibleText>
                    <span class="suggested-themes__loading-spinner spinner"></span>
                  </div>
                </button>
                <div
                  class="message__block message__block--warning"
                  v-if="this.searchMode == 'semantic' && !this.selectedCustomModels.length"
                >
                  <VisibleText>
                    This mode needs at least one model. Select one from the left.
                  </VisibleText>
                </div>
              </div>
            </div>
          </div>

          <div
            style="display: flex; flex-direction: column; margin: 0 1rem; width: 100%"
            v-if="searchMode == 'cluster'"
          >
            <div style="font-size: 1rem; text-align: center; line-height: 1; margin-bottom: 1rem">
              <VisibleText>
                Group similar sentences into topics automatically. (Unsupervised learning)
              </VisibleText>
            </div>

            <div style="display: flex; flex-direction: row" class="model-picker">
              <div style="display: flex; flex-direction: column; margin: 0 1rem">
                <!-- Header -->
                <div style="display: flex; flex-direction: row; margin-right: auto">
                  <div style="margin-right: auto">
                    <SvgIconDecorative style="height: 2rem; margin-right: 1rem" icon="brain" />
                  </div>
                  <h4 style="font-size: 1rem">
                    <VisibleText> GenAI-based topics </VisibleText>
                  </h4>
                </div>

                <!-- Checkbox -->
                <div
                  style="display: flex; flex-direction: row; margin: 0 1rem"
                  @click="checkForWarning()"
                >
                  <input
                    type="radio"
                    name="topic_logic"
                    class="datasets__table-checkbox"
                    style="width: 1.3rem; height: 1.3rem; margin-top: 0.5rem"
                    v-model="mode.topic_logic"
                    value="bert"
                    :disabled="!hasPreProcessedText || textAIStatus !== 'complete'"
                  />

                  <label
                    style="
                      text-align: right;
                      margin-right: 1rem;
                      margin-left: 1rem;
                      font-size: 0.8rem;
                    "
                    class="form-label"
                    :style="
                      !hasPreProcessedText || textAIStatus !== 'complete'
                        ? 'text-decoration: underline; cursor: pointer'
                        : ''
                    "
                  >
                    BERT + sentences
                  </label>
                </div>

                <!-- Granularity Slider (only visible when BERT+sentences is enabled) -->
                <div
                  v-if="mode.topic_logic == 'bert'"
                  style="display: flex; flex-direction: column; margin: 0.5rem 1rem; gap: 0.3rem"
                >
                  <label style="font-size: 0.75rem; opacity: 0.8"> Topic granularity </label>

                  <div style="display: flex; flex-direction: row; align-items: center; gap: 0.5rem">
                    <!-- Slider -->
                    <input
                      type="range"
                      min="1"
                      max="4"
                      step="1"
                      v-model.number="mode.granularity"
                      style="flex: 1"
                    />

                    <!-- Numeric input -->
                    <input
                      type="number"
                      min="1"
                      max="4"
                      v-model.number="mode.granularity"
                      style="width: 3rem; padding: 0.2rem; font-size: 0.75rem"
                    />
                  </div>

                  <small style="font-size: 0.7rem; opacity: 0.6">
                    1 = coarse/large themes, 4 = very fine, many themes
                  </small>
                </div>
                <!-- Slider + Input (only active when checkbox is on) -->
                <div
                  v-if="mode.topic_logic == 'bert'"
                  style="display: flex; flex-direction: column; margin: 0.5rem 1rem; gap: 0.3rem"
                >
                  <label style="font-size: 0.75rem; opacity: 0.8"
                    >Aim for this number of themes: (Optional)</label
                  >

                  <div style="display: flex; flex-direction: row; align-items: center; gap: 0.5rem">
                    <!-- Slider -->
                    <input
                      type="range"
                      min="1"
                      max="20"
                      step="1"
                      v-model.number="mode.target_themes"
                      style="flex: 1"
                    />

                    <!-- Numeric input -->
                    <input
                      type="number"
                      min="1"
                      max="20"
                      v-model.number="mode.target_themes"
                      style="width: 3rem; padding: 0.2rem; font-size: 0.75rem"
                    />
                  </div>

                  <small style="font-size: 0.7rem; opacity: 0.6">
                    Leave blank for automatic topic detection
                  </small>
                </div>
              </div>

              <div style="display: flex; flex-direction: column; margin: 0 1rem">
                <div style="display: flex; flex-direction: row; margin-right: auto">
                  <div style="margin-left: auto">
                    <SvgIconDecorative
                      style="height: 2rem; margin-right: 1rem"
                      icon="statisticsGraph"
                    />
                  </div>
                  <h4 style="font-size: 1rem">
                    <VisibleText> Keyword topics </VisibleText>
                  </h4>
                </div>

                <div style="display: flex; flex-direction: row; margin: 0 auto">
                  <input
                    type="radio"
                    class="datasets__table-checkbox"
                    name="topic_logic"
                    id="and-logic"
                    style="width: 1.3rem; height: 1.3rem; margin-top: 0.5rem"
                    v-model="mode.topic_logic"
                    value="lda"
                  />
                  <label
                    for="or-logic"
                    style="
                      text-align: right;
                      margin-right: 1rem;
                      margin-left: 1rem;
                      font-size: 0.8rem;
                    "
                    class="form-label"
                  >
                    <VisibleText> LDA /LSI </VisibleText>
                  </label>
                </div>
              </div>
              <div class="advanced-options" style="margin-left: auto">
                <button
                  class="suggested-themes__empty-auto-generate-btn btn-default"
                  style="width: 15rem"
                  role="button"
                  @click.stop="autoGenerateThemes()"
                  :disabled="disableAutoGen"
                >
                  Generate themes
                </button>
                <div class="message__block message__block--warning" v-if="disableAutoGen">
                  <VisibleText>
                    This mode needs at least one cluster method. Select one from the left.
                  </VisibleText>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="showSentenceWarning && searchMode == 'cluster'"
          style="
            font-size: 0.9rem;
            margin-bottom: 1rem;
            margin-top: -1rem;
            padding: 1rem;
            width: 80%;
          "
          class="message__block message__block--warning"
          @click="checkForWarning()"
        >
          <VisibleText>
            Note that sentence-based AI requires you to preprocess sentences. This may take some
            time, especially for large datasets. You can continue to use the other text features in
            the mean time.
          </VisibleText>

          <div v-if="!textAIStatus">
            <button class="btn-secondary" style="" @click="preprocessAI" v-if="!propReadOnly">
              <SvgIconDecorative icon="information" style="margin: auto" />
              <VisibleText style="color: var(--base-colour); text-decoration: underline"
                >Click here to enable AI text analysis</VisibleText
              >
            </button>
          </div>
        </div>

        <div
          style="
            font-size: 0.9rem;
            margin-bottom: 1rem;
            margin-top: -1rem;
            padding: 1rem;
            width: 50%;
          "
          class="message__block message__block--warning"
          v-if="showBertError"
        >
          <VisibleText> Too few rows, could not generate topics. </VisibleText>
        </div>
        <!-- Generated Themes -->
        <div class="suggested-themes__wrapper">
          <div class="suggested-themes__loading" v-if="isLoading">
            <p class="suggested-themes__loading-text">
              <VisibleText>Generating themes... please wait a minute.</VisibleText>
              <span class="suggested-themes__loading-spinner spinner"></span>
            </p>
          </div>
          <div class="suggested-themes__loading" v-if="isSaving">
            <p class="suggested-themes__loading-text">
              <VisibleText>Saving...</VisibleText>
              <span class="suggested-themes__loading-spinner spinner"></span>
            </p>
          </div>
          <div v-if="!isLoading && !isSaving">
            <div
              class="suggested-themes__empty"
              v-if="!suggestedThemes || suggestedThemes.length === 0"
            >
              <VisibleText>No themes generated</VisibleText>
            </div>
            <div v-else>
              <div style="display: flex; flex-direction: row; position: relative; width: 100%">
                <h3 class="suggested-themes__heading">
                  <VisibleText>Suggested themes</VisibleText>
                </h3>
                <button
                  class="table__toolbar-btn"
                  style="
                    font-size: 0.8em;
                    padding: 0.3em 0.6em 0.3em 0.3em;
                    margin: 0.5rem 0.5rem 0 0.5rem;
                    height: 2rem;
                  "
                  :disabled="!suggestedThemes.length"
                  @click="saveAllSuggestedThemes()"
                >
                  <SvgIconDecorative icon="add" />
                  <VisibleText>Keep all themes</VisibleText>
                </button>
                <div style="display: flex; margin-left: auto">
                  <div
                    v-if="showSortType"
                    style="
                      z-index: 10;
                      background-color: white;
                      border-top: 0;
                      border-radius: 0 0 4px 4px;
                      color: var(--base-colour);
                      position: absolute;
                      margin-top: -2rem;
                      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
                      border: 1px solid var(--outline-colour);
                      border-radius: 8px;
                      margin-right: 24rem;
                      width: 13rem;
                    "
                  >
                    <div style="margin-left: 0.5rem; display: flex; flex-direction: row">
                      <div style="margin-top: 0.5rem; font-weight: 800">
                        <VisibleText> Select a sort type</VisibleText>:
                      </div>
                      <button
                        style="
                          border: 1px solid var(--outline-colour);
                          background: var(--secondary-ui-colour);
                          border-radius: 4px;
                          margin: 0.3rem 0.3rem 0 auto;
                          width: 1.5rem;
                          height: 1.5rem;
                        "
                        @click="showSortType = false"
                      >
                        <SvgIconMeaningful
                          style="cursor: pointer; width: 1rem; margin-left: -0.05rem"
                          class="complete-icon-svg"
                          icon="remove"
                          title="close"
                        />
                      </button>
                    </div>

                    <div class="theme-options-btn" @click="switchSort('coverage')">
                      <span style="margin-left: 0.5rem; margin-right: 0.5rem">%</span>
                      <VisibleText>Coverage</VisibleText>
                    </div>
                    <div class="theme-options-btn" @click="switchSort('alphabetical')">
                      <SvgIconDecorative icon="alphabet" />
                      <VisibleText>Alphabetical</VisibleText>
                    </div>
                    <div class="theme-options-btn" @click="switchSort('unsorted')">
                      <SvgIconDecorative icon="timeAdd" />
                      <VisibleText>Unsorted</VisibleText>
                    </div>
                  </div>
                </div>
                <div style="display: flex; flex-direction: column">
                  <span style="font-size: 0.8rem"> Sort </span>
                  <div style="display: flex; flex-direction: row">
                    <ButtonIconOnly
                      :smaller="true"
                      style="
                        border: 1px solid var(--outline-colour);
                        background: var(--secondary-ui-colour);
                        border-radius: 4px;
                        margin: 0.5rem;
                      "
                      :icon="sortIcon"
                      @click-handler="showSortType = !showSortType"
                    >
                      <VisibleText style="font-weight: 800"
                        >sorting by: {{ themesSortType }}</VisibleText
                      >
                    </ButtonIconOnly>
                    <div style="width: 4rem">
                      <ButtonIconOnly
                        v-show="themesSortType != 'unsorted'"
                        :smaller="true"
                        style="
                          border: 1px solid var(--outline-colour);
                          background: var(--secondary-ui-colour);
                          border-radius: 4px;
                          margin: 0.5rem;
                        "
                        :icon="themesSortOrder"
                        @click-handler="switchSortOrder"
                      >
                        <VisibleText style="font-weight: 800"
                          >sort order: {{ themesSortOrder }}</VisibleText
                        >
                      </ButtonIconOnly>
                    </div>
                  </div>
                </div>
              </div>

              <ThemeList
                v-if="suggestedThemes && textAnalysisObject"
                :textAnalysisObject="textAnalysisObject"
                :responses="unsortedResponses"
                :sortedThemes="sortedThemes"
                class="suggested-themes__list"
                ref="suggested-themes"
                :propReadOnly="propReadOnly"
                :refreshCoverage="refreshCoverage"
                type="keyword"
                :isAutoGenerated="true"
                :includeSmartCoverage="includeSmartCoverage"
                :hasPreProcessedText="hasPreProcessedText || textAIStatus == 'complete'"
                :themes="suggestedThemes"
                :duplicateIndex="
                  duplicateIndex.type == 'suggested-theme' ? duplicateIndex.index : -1
                "
                @update-theme-title="
                  renameThemeTitle(suggestedThemes[$event.index], $event.title, 'suggested-themes')
                "
                @addToListForSaving="addToListForSaving"
                @applyPatches="applyPatches($event)"
                @removeTheme="$emit('removeTheme', $event)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="modal-footer__options">
        <button
          class="btn-save btn-default"
          role="button"
          @click.stop="addToSavedThemes"
          :disabled="
            !newUnsavedChanges || textAnalysisObject.showSpinner || awaitingLoading || propReadOnly
          "
        >
          <div v-if="!awaitingLoading">
            <VisibleText>Close window</VisibleText>
          </div>
          <div v-else>
            <VisibleText>Loading</VisibleText>
          </div>
        </button>
        <div v-if="!themeList || themeList.length === 0">
          You need at least one theme selected for saving.
        </div>
        <div v-else-if="!newUnsavedChanges">No new themes to save</div>
        <button
          type="button"
          class="theme__helper-options-btn"
          @click="$emit('bannedKeywordsModalIsVisible')"
          style="margin-left: auto; width: 15rem"
        >
          <SvgIconDecorative icon="ban" />
          <VisibleText style="font-size: 0.8rem">banned keywords</VisibleText>
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
// Mixins
import ThemeListMixin from '../Mixins/themeListMixin.js';
import themeColorsMixin from '../../Mixins/themeColorsMixin.js';
import textAnalysisMixin from '../../Mixins/textAnalysisMixin.js';
import SvgIconDecorative from '@/components/UI/Svg/SvgIconDecorative.vue';
import ButtonIconOnly from '@/components/UI/Button/ButtonIconOnly.vue';
import SvgIconMeaningful from '@/components/UI/Svg/SvgIconMeaningful.vue';
import EditableKeywordsPopup from '@/components/Project/ProjectAnalysis/ProjectAnalysisText/Components/EditableKeywordsPopup.vue';
import NotesPopup from '@/components/Project/ProjectAnalysis/ProjectAnalysisText/Components/NotesPopup.vue';
import SentimentPopup from '@/components/Project/ProjectAnalysis/ProjectAnalysisText/Components/SentimentPopup.vue';
import SourcePopup from '@/components/Project/ProjectAnalysis/ProjectAnalysisText/Components/SourcePopup.vue';
import CoveragePopup from '@/components/Project/ProjectAnalysis/ProjectAnalysisText/Components/CoveragePopup.vue';
import InputEditable from '../UI/InputEditable.vue';
// Utils
import { fetchGroups } from '@/components/CustomTopicModel/Utils/fetch.js';
// Services
import DatasetsService from '@/services/datasetsService.js';
import moment from 'moment';

export default {
  name: 'ThemesAutoGenerate',
  mixins: [ThemeListMixin, textAnalysisMixin, themeColorsMixin],
  components: {
    SvgIconDecorative,
    ButtonIconOnly,
    SvgIconMeaningful,
    EditableKeywordsPopup,
    NotesPopup,
    SentimentPopup,
    SourcePopup,
    CoveragePopup,
    InputEditable,
  },
  props: {
    show: {
      default: () => false,
      type: Boolean,
    },
    textAnalysisObject: {
      type: Object,
      required: false,
      default: () => {},
    },
    hasPreProcessedText: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    includeSmartCoverage: {
      type: String,
      default: () => 'exclude',
    },
    sortedThemes: {
      type: Array,
      default: () => [],
    },
    unsortedResponses: {
      type: Array,
      default: () => [],
    },
    propReadOnly: {
      default: () => false,
      type: Boolean,
    },
    themesReloading: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      DATASETS_SERVICE: new DatasetsService(this.$pigeonline),
      isLoading: false,
      isSaving: false,
      suggestedThemes: [],
      originalSuggestedThemes: [],
      duplicateIndex: { type: '', index: -1 },
      refreshCoverage: false,
      spinnerQueue: [],
      mode: {
        keyword_topics: false,
        sentence_topics: false,
        private_custom_topics: true,
        team_custom_topics: true,
        public_custom_topics: false,
        include_custom_sentences: false,
        include_all_themes: false,
        include_machine_learning: true,
        target_themes: null,
        granularity: 2,
        topic_logic: 'bert',
      },
      searchMode: 'semantic',
      showSortType: false,
      themesSortType: 'coverage',
      themesSortOrder: 'descending',
      showSentenceWarning: false,
      showBertError: false,
      topicModelGroups: [],
      selectedCustomModels: [],
      searchCustomModelQuery: '',
      textAIStatus: '',
      counter: 0,
      timer: null,
      suggestedCMTMatches: [],
    };
  },
  computed: {
    awaitingLoading() {
      if (this.spinnerQueue.length) {
        return true;
      }
      return false;
    },
    filteredCustomModels() {
      let topicModelGroups = this.topicModelGroups;
      if (!this.mode.public_custom_topics) {
        topicModelGroups = topicModelGroups.filter((model) => model.access_type !== 'public__all');
      }
      if (!this.mode.team_custom_topics) {
        topicModelGroups = topicModelGroups.filter((model) => model.access_type !== 'public__team');
      }
      if (!this.mode.private_custom_topics) {
        topicModelGroups = topicModelGroups.filter((model) => model.access_type !== 'private');
      }

      topicModelGroups = topicModelGroups.filter(
        (model) => !this.selectedCustomModels.includes(model.id),
      );

      return topicModelGroups.filter((model) =>
        model.name.toLowerCase().includes(this.searchCustomModelQuery.toLowerCase()),
      );
    },
    sortIcon() {
      let icon = 'percentage';
      if (this.themesSortType == 'coverage') {
        icon = 'percentage';
      }
      if (this.themesSortType == 'alphabetical') {
        icon = 'alphabet';
      }
      if (this.themesSortType == 'unsorted') {
        icon = 'minus';
      }
      return icon;
    },
    filteredSelectedCustomModels() {
      let topicModelGroups = this.topicModelGroups;

      topicModelGroups = topicModelGroups.filter((model) =>
        this.selectedCustomModels.includes(model.id),
      );

      return topicModelGroups;
    },
    disableAutoGen() {
      if (this.searchMode == 'cluster') {
        if (!this.mode.topic_logic == 'lda' && this.mode.topic_logic != 'bert') {
          return true;
        }
      }
      if (this.searchMode == 'semantic') {
        if (!this.selectedCustomModels.length) {
          return true;
        }
      }
      return false;
    },
    savedWidth() {
      if (this.themeList.length) {
        return 25;
      }
      return 15;
    },
    newUnsavedChanges() {
      if (this.themeList.filter((theme) => theme.is_autogenerated).length) {
        return true;
      }
      return false;
    },
  },
  methods: {
    refreshThemesFromParent() {
      this.themeList = this.deepCloneObj(this.sortedThemes);
      this.isSaving = false;
    },
    updateTextObject(cleanedProject) {
      let object = {
        project: cleanedProject,
        scroll: 'themes',
      };
      this.$emit('updateTextObject', object);
    },
    updateTheme(theme) {
      this.$emit('updateTheme', theme);
    },
    updateSpinner(val) {
      this.spinnerQueue = val;
    },
    getConsolidatedThemeTitles() {
      // for checking duplicates
      return [...this.themeList, ...this.suggestedThemes].map((el) => el.name.trim().toLowerCase());
    },

    // Works fine, but if pressing over existing, does not 'clear' properly, returns the old themes too early
    async autoGenerateThemes() {
      this.isLoading = true;
      this.suggestedThemes = [];
      let useThisID = this.textAnalysisObject.selectedTextQuestion._id;
      if (useThisID.$oid) {
        useThisID = useThisID.$oid;
      }
      // ----------
      //  Semantic mode (using custom models)
      // ----------
      let custom_topic_models = [];
      if (this.searchMode == 'semantic') {
        if (this.selectedCustomModels && this.selectedCustomModels.length) {
          custom_topic_models = this.selectedCustomModels;
          try {
            let smart_coverage = false;
            if (this.includeSmartCoverage === 'include') {
              smart_coverage = true;
            }
            const new_suggested_themes_result = await this.generateThemesFromModels({
              questionId: useThisID,
              filter_params: this.textAnalysisObject.filterParams,
              smart_coverage: smart_coverage,
              model_ids: custom_topic_models,
              include_all_themes: this.mode.include_all_themes,
              include_machine_learning: this.mode.include_machine_learning,
            });
            if (
              new_suggested_themes_result.status &&
              new_suggested_themes_result.status == 'queued'
            ) {
              //begin polling

              this.getSuggestedThemes();
            }
          } catch (e) {
            this.showModalMessage(
              'error',
              'An error occured processing your request. Please try again later.',
            );
          }
        }
      }

      // ----------
      //  Cluster mode (topic modelling)
      // ----------
      if (this.searchMode == 'cluster') {
        let all_modes = [];
        let target_themes = 'auto';
        let granularity = 2;

        if (this.mode.topic_logic == 'lda') {
          all_modes.push('keyword_topics');
        }
        if (this.mode.topic_logic == 'bert') {
          all_modes.push('sentence_topics');
        }
        if (this.mode.target_themes) {
          target_themes = this.mode.target_themes;
        }
        if (this.mode.granularity) {
          granularity = this.mode.granularity;
        }
        try {
          let smart_coverage = false;
          if (this.includeSmartCoverage === 'include') {
            smart_coverage = true;
          }

          for (let i = 0; i < all_modes.length; i++) {
            if (all_modes[i] == 'sentence_topics') {
              const new_suggested_themes = await this.generateBertSentenceTopics({
                questionId: useThisID,
                text_analysis_uuid: this.textAnalysisObject.uuid,
                filter_params: this.textAnalysisObject.filterParams,
                smart_coverage: smart_coverage,
                target_themes: target_themes,
                granularity: granularity,
              });
              if (
                new_suggested_themes.status &&
                (new_suggested_themes.status == 'queued' ||
                  new_suggested_themes.status == 'updating')
              ) {
                //begin polling
                this.getSuggestedThemes();
              }
              // May not be working
              if (new_suggested_themes == 'error: too small') {
                this.showBertError = true;
              }
            } else {
              const new_suggested_themes = await this.generateLDATopics({
                questionId: useThisID,
                text_analysis_uuid: this.textAnalysisObject.uuid,
                filter_params: this.textAnalysisObject.filterParams,
                smart_coverage: smart_coverage,
              });
              if (
                new_suggested_themes.status &&
                (new_suggested_themes.status == 'queued' ||
                  new_suggested_themes.status == 'updating')
              ) {
                //begin polling
                this.getSuggestedThemes();
              }
            }
          }
        } catch (e) {
          this.showModalMessage(
            'error',
            'An error occured processing your request. Please try again later.',
          );
        }
      }
    },
    addKeyword(newKeyword) {
      const themeId = newKeyword.theme._id;
      const keywordText = newKeyword.text;

      const theme = this.themeList.find((t) => {
        const id = t._id?.$oid || t._id;
        return id === themeId;
      });
      if (!theme) return;

      // Extract keyword strings from keyword_objects
      const existingKeywords = theme.keyword_objects.map((ko) => ko.keyword);

      // Already exists → do nothing
      if (existingKeywords.includes(keywordText)) return;

      // Emit change instruction (your standard pattern)
      this.$emit('updateTheme', {
        _id: themeId,
        keywords_to_add: [keywordText],
      });
    },

    removeKeyword(newKeyword) {
      const themeId = newKeyword.theme._id;
      const keywordText = newKeyword.text;

      // Find the theme in the list
      const theme = this.themeList.find((t) => {
        const id = t._id?.$oid || t._id;
        return id === themeId;
      });
      if (!theme) return;
      // Extract keyword strings from keyword_objects
      const existingKeywords = theme.keyword_objects.map((ko) => ko.keyword);
      // If the keyword doesn't exist → nothing to remove
      if (!existingKeywords.includes(keywordText)) return;

      // Emit the same update format used everywhere else
      this.$emit('updateTheme', {
        _id: themeId,
        keywords_to_remove: [keywordText],
      });
    },

    applyPatches(patches) {
      patches.forEach((patch) => {
        const patchId = this.normalizeId(patch._id);

        const theme = this.suggestedThemes.find((t) => {
          const themeId = this.normalizeId(t._id);
          return themeId === patchId;
        });

        if (!theme) {
          // eslint-disable-next-line
          console.warn('No matching theme found for patch', patch);
          return;
        }

        if (theme.suggested) {
          this.patchSuggestedTheme(patch);
        }
      });
    },

    normalizeId(id) {
      if (!id) return null;
      return typeof id === 'string' ? id : id.$oid;
    },

    async patchSuggestedTheme(patch) {
      // TODO apply loading graphic to individual theme
      await this.TEXT_SERVICE.patchSuggestedTheme(patch);
      // Poll only this theme
      await this.getSuggestedTheme(this.normalizeId(patch._id));
    },

    switchSort(sort_type) {
      this.themesSortType = sort_type;
      this.showSortType = false;
      this.reSortThemes();
    },
    switchSortOrder() {
      if (this.themesSortOrder == 'descending') {
        this.themesSortOrder = 'ascending';
        this.reSortThemes();
      } else {
        this.themesSortOrder = 'descending';
        this.reSortThemes();
      }
    },
    async reSortThemes() {
      const themes = this.deepCloneObj(this.suggestedThemes);
      const isFiltered =
        this.textAnalysisObject.filterParams &&
        Object.keys(this.textAnalysisObject.filterParams).length > 0;

      // Helper: get correct coverage count
      const getCount = (theme) =>
        isFiltered ? theme.filtered_coverage?.total || 0 : theme.coverage?.total || 0;

      // 1. Coverage sort
      if (this.themesSortType === 'coverage') {
        themes.sort((a, b) => {
          const diff = getCount(a) - getCount(b);
          return this.themesSortOrder === 'ascending' ? diff : -diff;
        });

        this.suggestedThemes = themes;
        return;
      }

      // 2. Alphabetical sort
      if (this.themesSortType === 'alphabetical') {
        themes.sort((a, b) => {
          const diff = a.name.localeCompare(b.name);
          return this.themesSortOrder === 'ascending' ? diff : -diff;
        });

        this.suggestedThemes = themes;
        return;
      }

      // 3. Unsorted
      if (this.themesSortType === 'unsorted') {
        this.suggestedThemes = this.originalSuggestedThemes;
        return;
      }
    },

    async renameThemeTitle(theme, title, type) {
      if (this.suggestedThemes && type == 'suggested-themes') {
        let themes = this.deepCloneObj(this.suggestedThemes);
        if (typeof title !== 'string' || title.trim() === '') {
          title = 'unnamed theme';
        }

        let matchingIndex = -1;
        for (let i = 0; i < themes.length; i++) {
          if (themes[i]._id === theme._id) {
            matchingIndex = i;
          }
        }
        let foundExisting = false;
        for (let i = 0; i < this.sortedThemes.length; i++) {
          if (
            this.sortedThemes[i].name &&
            this.sortedThemes[i].name.toLowerCase() == title.toLowerCase()
          ) {
            foundExisting = true;
          }
        }
        if (matchingIndex > -1 && !foundExisting) {
          themes[matchingIndex].name = title;
          this.suggestedThemes = themes;
        }
        if (matchingIndex > -1 && foundExisting) {
          this.duplicateIndex = {
            type: 'suggested-theme',
            index: matchingIndex,
          };
          setTimeout(() => {
            this.duplicateIndex = { type: '', index: -1 };
          }, 6000);
        }
      }

      if (this.themeList && type == 'theme-list') {
        let themes = this.deepCloneObj(this.themeList);
        if (typeof title !== 'string' || title.trim() === '') {
          title = 'unnamed theme';
        }

        let matchingIndex = -1;
        for (let i = 0; i < themes.length; i++) {
          if (themes[i]._id === theme._id) {
            matchingIndex = i;
          }
        }
        let foundExisting = false;
        for (let i = 0; i < this.sortedThemes.length; i++) {
          if (this.sortedThemes[i].name && themes[i].name.toLowerCase() == title.toLowerCase()) {
            foundExisting = true;
          }
        }
        if (matchingIndex > -1 && !foundExisting) {
          themes[matchingIndex].name = title;
          this.themeList = themes;
          this.$emit('updateExistingThemeTitle', themes[matchingIndex], title);
        }
        if (matchingIndex > -1 && foundExisting) {
          this.duplicateIndex = { type: 'theme-list', index: matchingIndex };
          setTimeout(() => {
            this.duplicateIndex = { type: '', index: -1 };
          }, 6000);
        }
      }
    },
    async addToListForSaving(theme) {
      const newThemePayload = {
        text_analysis_uuid: theme.text_analysis_uuid,
        name: theme.name,
        theme_color: theme.theme_color,
        notes: theme.notes || [],
        keyword_objects: theme.keyword_objects || [],
        dropped: theme.dropped,
        ml_dropped: theme.ml_dropped,

        // Preserve model origin
        source: theme.source || null,

        // Preserve coverage-related fields
        coverage: theme.coverage || {},
        filtered_coverage: theme.filtered_coverage || {},

        // Preserve filter params
        filter_params: theme.filter_params || null,
      };

      // 1. Create official theme
      const createdTheme = await this.TEXT_SERVICE.createTheme(newThemePayload);

      // 2. Delete suggested theme
      await this.TEXT_SERVICE.deleteSuggestedTheme(theme._id);

      // 3. Remove from FE list
      this.suggestedThemes = this.suggestedThemes.filter((t) => t._id !== theme._id);

      // 4. Ask parent to refresh
      this.$emit('refreshTheme', createdTheme._id);
    },

    async saveAllSuggestedThemes() {
      if (!this.suggestedThemes.length) return;
      this.isSaving = true;
      this.isLoading = true;
      const cleanedThemes = this.suggestedThemes.map((t) => ({
        text_analysis_uuid: t.text_analysis_uuid,
        name: t.name,
        theme_color: t.theme_color,
        notes: t.notes || [],
        keyword_objects: t.keyword_objects || [],
        source: t.source || null,
        filter_params: t.filter_params || null,

        // coverage fields
        coverage: t.coverage || {},
        filtered_coverage: t.filtered_coverage || {},

        created_on: moment().valueOf(),
      }));

      // 1. Bulk-create official themes
      const result = await this.TEXT_SERVICE.createThemes({
        text_analysis_uuid: this.textAnalysisObject.uuid,
        themes: cleanedThemes,
      });

      // 2. Delete all suggested themes
      this.TEXT_SERVICE.deleteAllSuggestedThemes({
        project_id: this.project.id,
        text_analysis_uuid: this.textAnalysisObject.uuid,
      });

      // 3. Clear FE list
      this.suggestedThemes = [];

      // 4. Refresh parent
      this.$emit('refreshThemes', result.created_theme_ids);
      this.isLoading = false;
    },

    removeFromListForSaving(theme) {
      for (let i = 0; i < this.themeList.length; i++) {
        if (this.themeList[i]._id === theme._id) {
          this.themeList.splice(i, 1);
        }
      }
      this.suggestedThemes.push(theme);
    },
    checkForWarning() {
      if (!this.hasPreProcessedText && this.textAIStatus !== 'complete') {
        this.showSentenceWarning = !this.showSentenceWarning;
        if (this.mode.topic_logic == 'bert') {
          this.mode.topic_logic = 'lda';
        }
        if (this.mode.include_machine_learning) {
          this.mode.include_machine_learning = false;
        }
      }
    },
    async GetCTMs() {
      this.topicModelGroups = await fetchGroups();
      if (
        this.textAnalysisObject.customTopicModels &&
        this.textAnalysisObject.customTopicModels.length
      ) {
        const preSelectedIds = this.textAnalysisObject.customTopicModels;
        // Filter your full model list by matching IDs
        this.selectedCustomModels = this.topicModelGroups
          .filter((model) => preSelectedIds.includes(model.id))
          .map((model) => model.id);
      }
    },
    toggleSelection(model) {
      const id = model.id;
      const index = this.selectedCustomModels.indexOf(id);

      if (index !== -1) {
        this.selectedCustomModels.splice(index, 1);
      } else {
        this.selectedCustomModels.push(id);
      }

      this.$emit('updateSelectedCustomModels', this.selectedCustomModels);
    },

    async preprocessAI() {
      if (Object.keys(this.textAnalysisObject.selectedTextQuestion).length) {
        if (this.textAnalysisObject.selectedTextQuestion._id) {
          let questionID = this.textAnalysisObject.selectedTextQuestion._id;
          if (this.textAnalysisObject.selectedTextQuestion._id.$oid) {
            questionID = this.textAnalysisObject.selectedTextQuestion._id.$oid;
          }

          await this.DATASETS_SERVICE.preproccessAI({
            client_question_id: questionID,
          });
          this.startTimer();
        }
      }
    },
    async checkAIProcessingAnalysis() {
      if (Object.keys(this.textAnalysisObject.selectedTextQuestion).length) {
        if (this.textAnalysisObject.selectedTextQuestion._id) {
          let questionID = this.textAnalysisObject.selectedTextQuestion._id;
          if (this.textAnalysisObject.selectedTextQuestion._id.$oid) {
            questionID = this.textAnalysisObject.selectedTextQuestion._id.$oid;
          }
          const results = await this.DATASETS_SERVICE.checkAIProcessingService({
            client_question_id: questionID,
          });
          if (results.status == 'processing') {
            this.textAIStatus = 'processing';
          }
          if (results.status == 'complete') {
            this.textAIStatus = 'complete';
            this.stopTimer();
          }
          if (results.status == 'not_started') {
            this.stopTimer();
          }
        }
      }
    },

    async getSuggestedTheme(themeId) {
      const payload = {
        text_analysis_uuid: this.textAnalysisObject.uuid,
        theme_ids: [themeId],
      };

      const pollInterval = 750;
      const maxAttempts = 10000;
      let attempt = 0;

      while (attempt < maxAttempts) {
        attempt++;

        const response = await this.TEXT_SERVICE.getSuggestedThemes(payload);

        // Do NOT clear the list when updating
        if (response.status === 'updating') {
          await new Promise((resolve) => setTimeout(resolve, pollInterval));
          continue;
        }

        // Ready → update only this theme
        if (response.status === 'ready') {
          const updatedTheme = response.themes[0];

          const idx = this.suggestedThemes.findIndex((t) => this.normalizeId(t._id) === themeId);

          if (idx !== -1) {
            this.suggestedThemes.splice(idx, 1, updatedTheme);
          }

          return;
        }
      }

      this.showModalMessage(
        'error',
        'Theme update is taking longer than expected. Please try again.',
      );
    },

    async getSuggestedThemes() {
      let proj_id = this.project.id.$oid || this.project.id;
      this.isLoading = true;

      const payload = {
        client_question_id: this.selectedTextQuestionId,
        project_id: proj_id,
        text_analysis_uuid: this.textAnalysisObject.uuid,
      };

      const pollInterval = 750;
      const maxAttempts = 10000;
      let attempt = 0;

      while (attempt < maxAttempts) {
        attempt++;

        const response = await this.TEXT_SERVICE.getSuggestedThemes(payload);

        const status = response.status; // "updating" | "ready"
        const themes = response.themes || [];

        // Still processing → keep polling
        if (status === 'updating') {
          if (response.progress) {
            this.suggestedProgress = response.progress;
          }
          await new Promise((resolve) => setTimeout(resolve, pollInterval));
          continue;
        }

        // Status === "ready"
        this.originalSuggestedThemes = themes;

        if (themes.length === 0) {
          this.suggestedThemes = [];
          this.isLoading = false;
          return;
        }

        // Clone themes for sorting
        let sortedThemes = this.deepCloneObj(themes);

        const isFiltered =
          this.textAnalysisObject.filterParams &&
          Object.keys(this.textAnalysisObject.filterParams).length > 0;

        // Helper: unified coverage count
        const getCount = (theme) =>
          isFiltered ? theme.filtered_coverage?.total || 0 : theme.coverage?.total || 0;

        // Sort by coverage (descending by default)
        sortedThemes.sort((a, b) => getCount(b) - getCount(a));

        // Validate theme titles
        sortedThemes.forEach((el) => {
          el.name = this.getValidatedThemeTitle(
            el.name,
            el.name,
            this.getConsolidatedThemeTitles(),
          );
        });

        this.suggestedThemes = sortedThemes;
        this.isLoading = false;
        return;
      }

      // Timeout
      this.showModalMessage(
        'error',
        'Theme generation is taking longer than expected. Please try again.',
      );
    },

    // for text AI status checking
    incrementCounter() {
      this.counter++;
    },
    startTimer() {
      this.timer = setTimeout(
        function repeat() {
          this.checkAIProcessingAnalysis();
          this.incrementCounter();
          this.timer = setTimeout(repeat.bind(this), 2000); // Adjust interval as needed
        }.bind(this),
        1000,
      );
    },
    stopTimer() {
      clearTimeout(this.timer);
    },
  },

  async mounted() {
    await this.GetCTMs();
    await this.getSuggestedThemes();
    await this.checkForWarning();
    this.startTimer();
  },

  watch: {
    show: function (val) {
      if (val) {
        if (this.sortedThemes.length) {
          this.themeList = this.deepCloneObj(this.sortedThemes);
        }
      }
    },
  },
};
</script>

<style scoped>
.model-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-start;
  font-family: sans-serif;
  padding: 1rem;
  border: 1px solid #eee;
  border-radius: 6px;
  background: #fff;
  width: 95%;
}

/* Filters and search */
.model-filters {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 340px;
}

.model-filters .filter-bar {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.filter-bar button {
  padding: 0.4rem 0.8rem;
  border: 1px solid #ccc;
  background: #f9f9f9;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
}

.filter-bar button.active {
  background: #0078d4;
  color: white;
  border-color: #0078d4;
}

.model-filters input[type='text'] {
  padding: 0.4rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

/* Selected tags */
.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
  max-height: 5rem;
  overflow-y: auto;
}

.selected-tags .tag {
  background: #e0f0ff;
  padding: 0.3rem 0.6rem;
  border-radius: 20px;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
}

.selected-tags .tag button {
  background: none;
  border: none;
  margin-left: 0.4rem;
  cursor: pointer;
  font-size: 1rem;
}

/* Model list */
.model-list {
  flex: 1;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 0.5rem;
  min-width: 250px;
}

.model-list li {
  margin-bottom: 0.3rem;
  margin-left: 1rem;
}

.model-list label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Advanced options */
.advanced-options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 350px;
}

.advanced-options label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  margin-left: 1rem;
}

/* Action button */
.generate-button {
  margin-top: auto;
  padding: 0.6rem 1rem;
  background: #0078d4;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
}

.view-link {
  margin-left: 0.5rem;
  font-size: 0.8rem;
  color: #0078d4;
  text-decoration: underline;
  cursor: pointer;
}

.view-link:hover {
  text-decoration: none;
}

.model-select {
  max-width: 400px;
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 6px;
}
.model-select-left {
  margin-right: 0.5rem;
}
.model-select-right {
  margin-left: 0.5rem;
}
ul {
  list-style: none;
  padding: 0;
  margin: 8px 0;
  max-height: 240px;
  overflow-y: auto;
}
li {
  padding: 6px 10px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
li.selected {
  background-color: #dfeffd;
}

.search-mode-toggle-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto 1rem auto;
}

.search-mode-toggle {
  display: inline-flex;
  border: 1px solid #d0d7de;
  border-radius: 8px;
  overflow: hidden;
}

.search-mode-toggle label {
  padding: 10px 16px;
  cursor: pointer;
  font-size: 14px;
  background: #f6f8fa;
  color: #444;
  border-right: 1px solid #d0d7de;
  user-select: none;
  transition:
    background 0.15s,
    color 0.15s;
}

.search-mode-toggle label:last-child {
  border-right: none;
}

.search-mode-toggle input {
  display: none;
}

.search-mode-toggle label.active {
  background: var(--primary);
  color: white;
}
</style>
